import Controls from './Controls';
export default Controls;
